import { render, staticRenderFns } from "./secondaryContent.vue?vue&type=template&id=99b83216&scoped=true"
import script from "./secondaryContent.vue?vue&type=script&lang=js"
export * from "./secondaryContent.vue?vue&type=script&lang=js"
import style0 from "./secondaryContent.vue?vue&type=style&index=0&id=99b83216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b83216",
  null
  
)

export default component.exports